import React from 'react';
import { connect } from 'react-redux';
import Statistic from './Statistic';
import SearchBarHeader from './SearchBarHeader';
import SearchBarContent from './SearchBarContent';
import DetailContainer from './DetailContainer';

export const SearchBar = (props) => (

      <div className="searchBar-container">
      <SearchBarHeader type="searchBar-header" background={props.background} showProfile={true}/>
        {
          props.detailView ? (
            <DetailContainer />
          ) :  (
            <div>
              <SearchBarContent />
              <Statistic /> 
            </div>
          )
        }
      </div>
    )

const mapStateToProps = (state) => {
  return {
    detailView: state.globalState.detailView
  };
};
export default connect(mapStateToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/SearchBar.js